import { formatNumber } from 'core/service/lib/number-format'
import BIMESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'

const SummaryRow = ({
  id,
  productCode,
  productName,
  asterisks = '',
  coverageYear,
  paymentPeriod,
  sumAssured,
  premium,
}) => {
  const displayProductName = `${productName} (${productCode})${asterisks}`
  const isBumnanReady = VALUES.BUMNAN_READY_CODE_GROUP.includes(productCode)
  const isBumnanSmart = VALUES.BUMNAN_SMART_GROUP.includes(productCode)

  const coveragePeriod = isBumnanSmart
    ? BIMESSAGES.COVERAGE_PERIOD_BUMNAN_SMART_SUFFIX
    : BIMESSAGES.COVERAGE_PERIOD_BUMNAN_READY_SUFFIX

  return isBumnanReady || isBumnanSmart ? (
    <tr id={`summary-row-${id}`}>
      <td>{displayProductName}</td>
      <td>{coveragePeriod}</td>
      <td>{paymentPeriod}</td>
      <td>{sumAssured}</td>
      <td>{formatNumber(premium, 2)}</td>
    </tr>
  ) : (
    <tr id={`summary-row-${id}`}>
      <td>{displayProductName}</td>
      <td>{coverageYear}</td>
      <td>{paymentPeriod}</td>
      <td>{sumAssured}</td>
      <td>{formatNumber(premium, 2)}</td>
    </tr>
  )
}

export default SummaryRow
